export default "__VITE_PUBLIC_ASSET__47f1d556__"